import {
    Box,
    chakra,
    Flex,
    Image,
    Divider,
    AbsoluteCenter,
    SimpleGrid,
    Link,
} from '@chakra-ui/react';


const EventIntro_8 = ({ activity }) => {
    return (
        <Flex
            textAlign={'center'}
            pt={10}
            justifyContent={'center'}
            direction={'column'}
            width={'full'}>
            <Box width="100%" margin={'auto'}>
                <chakra.h1
                    py={5}
                    fontSize={40}
                    fontWeight={'bold'}
                    color={'gray.700'}
                    >
                    {activity.title}
                </chakra.h1>
            </Box>
            <Box
                boxShadow={'lg'}
                alignItem={'center'}
                width={'100%'}
                rounded={'xl'}
                p={10}
                position={'relative'}
                bg={'white'}
                _after={{
                    content: '""',
                    position: 'absolute',
                    height: '50px',
                    width: '50px',
                    left: '25px',
                    top: '-20px',
                    backgroundSize: 'cover',
                    backgroundImage: "url('/quotation_marks.png')",
                }}>
                <Box position='relative' padding='10'>
                    <Divider  borderColor={'gray.400'}/>
                    <AbsoluteCenter bg='white' px='4'>
                        <chakra.h2
                            py={5}
                            fontSize={35}
                            fontWeight={'bold'}
                            color={'gray.700'}
                            >
                            活動簡介
                        </chakra.h2>
                    </AbsoluteCenter>
                </Box>
                <Box
                    textAlign={'left'}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.intro}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                        color={'gray.600'}
                        pb={2}
                    >
                        時　　間｜{activity.date} {activity.time}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                        color={'gray.600'}
                        pb={4}
                    >
                        地　　點｜{activity.place}
                    </chakra.p>
                </Box>
                <Flex>
                    <Image
                        src={`../activity/${activity.fileName}`}
                        alt="NONE"
                        mx="auto"
                    />
                </Flex>
                <Box position='relative' padding='10' mt='8'>
                    <Divider  borderColor={'gray.400'}/>
                    <AbsoluteCenter bg='white' px='4'>
                        <chakra.h2
                            py={5}
                            fontSize={35}
                            fontWeight={'bold'}
                            color={'gray.700'}
                            >
                            活動總覽
                        </chakra.h2>
                    </AbsoluteCenter>
                </Box>
                <Box textAlign={'left'}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[0]}
                    </chakra.p>
                    <Flex pb={4}>
                        <Box width="100%">
                            <Image src={`../activity/${activity.pics[0]}`} alt='NONE' mx="auto"/>
                        </Box>
                    </Flex>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[1]}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[2]}
                    </chakra.p>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        {activity.paragraph[3]}
                    </chakra.p>
                </Box>
                <Box position='relative' padding='10' mb='2'>
                    <Divider  borderColor={'gray.400'}/>
                    <AbsoluteCenter bg='white' px='4'>
                        <chakra.h2
                            py={5}
                            fontSize={35}
                            fontWeight={'bold'}
                            color={'gray.700'}
                            >
                            活動照片
                        </chakra.h2>
                    </AbsoluteCenter>
                </Box>
                <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                    <Image src={`../activity/${activity.pics[1]}`} alt="NONE" objectFit="cover" width="100%" height="280px" borderRadius="md"/>
                    <Image src={`../activity/${activity.pics[2]}`} alt="NONE" objectFit="cover" width="100%" height="280px" borderRadius="md"/>
                    <Image src={`../activity/${activity.pics[3]}`} alt="NONE" objectFit="cover" width="100%" height="280px" borderRadius="md"/>
                </SimpleGrid>
                <br/>
                <Box textAlign={'left'}>
                    <chakra.p
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'18px'}
                    >
                        {activity.paragraph[4]} <br/>
                        {activity.paragraph[5]} <br/>
                        {activity.paragraph[6]}
                    </chakra.p>
                    <Link color="#437070" href={activity.link[0]} isExternal>
                        活動詳情請參見官方網站
                    </Link>
                </Box>

            </Box>
        </Flex>
    )
}
export default EventIntro_8;
